import { getContext } from '@/context';

/**
 * The host runtime populates `general.auth` with `IContextUser` — `id` is set
 * only when the user is authenticated, and there is NO `isAuthorized` field.
 * A present Authorization header (token) is an equally valid "signed in"
 * signal and lands slightly earlier than the user profile. Either one means
 * the user is authenticated.
 */
const isAuthorized = (): boolean => {
  try {
    const ctx = getContext();
    if (ctx.general.auth.getState()?.id != null) return true;
    return Boolean(ctx.utils.api.getHeaders()?.Authorization);
  } catch {
    return false;
  }
};

export default isAuthorized;
